import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import getAxiosInstance, {BASE_URL_TYPE} from '../../api/axios';
import * as actionCreators from '../../store/actions/index';
import utilities from '../../utilities/utilities';
import PopupBase from './PopupBase';

const axios = getAxiosInstance();
const propTypes = {
  userData: PropTypes.instanceOf(Object).isRequired,
  setLoading: PropTypes.func.isRequired,
  closeEvent: PropTypes.func.isRequired,
  defaultMessage: PropTypes.string,
  formHeaderMessage: PropTypes.string,
  formConfirmationMessage: PropTypes.string,
};

const defaultProps = {
  defaultMessage: '',
  formHeaderMessage: null,
  formConfirmationMessage: null,
};

class ContactUsPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
    };

    // Class properties.
    this.ref = React.createRef();
    this.form = React.createRef();

    // Binding handlers.
    this.close = this.close.bind(this);
    this.save = this.save.bind(this);
    this.createHeaderHTML = this.createHeaderHTML.bind(this);
  }

  createHeaderHTML = content => ({__html: content});

  close(e) {
    const {closeEvent} = this.props;
    e.preventDefault();
    closeEvent();
  }

  save(e) {
    const {setLoading} = this.props;
    e.persist();
    e.preventDefault();
    const {current: formValues} = this.form;
    const data = {
      webform_id: 'talk_to_sales',
      name: formValues.name.value,
      email: formValues.email.value,
      phone_number: formValues.phone.value,
      message: formValues.message.value,
    };
    setLoading(true);
    axios
      .post(`${BASE_URL_TYPE.PROPZONE}/webform_rest/submit`, data)
      .then((result) => {
        if (result.data && result.data.sid) {
          this.setState({submitted: true});
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }

  render() {
    const {submitted} = this.state;
    const {
      closeEvent,
      defaultMessage,
      userData,
      formHeaderMessage,
      formConfirmationMessage,
    } = this.props;
    let defaultValues = {};
    if (utilities.isLoggedIn(userData)) {
      defaultValues = {
        name: `${_.get(userData, 'field_user_first_name')} ${_.get(
          userData,
          'field_user_last_name',
        )}`,
        email: _.get(userData, 'mail'),
        phone: _.get(userData, 'field_home_telephone'),
      };
    }
    let popupContent = (
      <div>
        {formConfirmationMessage
          || `Thank you! One of our representatives will be in touch soon. If you do not hear from us
              within two business days, please feel free to contact us directly at `}
        <a href="mailto:info@gridics.com" target="_blank" rel="noopener noreferrer">
          info@gridics.com
        </a>
        .
      </div>
    );
    if (!submitted) {
      popupContent = (
        <form ref={this.form} onSubmit={this.save}>
          <h3>{this.subject}</h3>
          <div className="notice">
            {formHeaderMessage ? (
              // eslint-disable-next-line react/no-danger
              <div dangerouslySetInnerHTML={this.createHeaderHTML(formHeaderMessage)} />
            ) : (
              'Please fill the information below to have a manager contact you to provide more information.'
            )}
          </div>
          <label htmlFor="name">Your info</label>
          <div className="flexbox-container">
            <div className="form-element text">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                defaultValue={_.get(defaultValues, 'name', '')}
              />
            </div>
            <div className="form-element email">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                defaultValue={_.get(defaultValues, 'email', '')}
              />
            </div>
          </div>
          <div className="flexbox-container">
            <div className="form-element phone">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                defaultValue={_.get(defaultValues, 'phone', '')}
              />
            </div>
          </div>
          <div className="form-element textarea">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" defaultValue={defaultMessage} />
          </div>
          <div className="buttons">
            <button type="button" onClick={this.close} className="btn-secondary">
              Cancel
            </button>
            <input type="submit" className="btn" value="Submit" />
          </div>
        </form>
      );
    }
    return (
      <PopupBase
        title="Contact Us"
        portal
        ref={this.ref}
        closeEvent={closeEvent}
        addBodyClasses={false}
      >
        {popupContent}
      </PopupBase>
    );
  }
}

ContactUsPopup.defaultProps = defaultProps;
ContactUsPopup.propTypes = propTypes;

const mapStateToProps = state => ({
  userData: state.user.userData,
});

const mapDispatchToProps = dispatch => ({
  setLoading: state => dispatch(actionCreators.setLoading(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsPopup);
